import React, { Fragment, useEffect, useState } from 'react'
import useCategoriesAdmin from '../../../../../Hooks/CategoriesAdmin'
import { useLocation } from 'react-router-dom'
import Form from '../../../../Common/Form'
import InputButton from '../../../../Common/InputButton'
import SelectCategory from '../../../../Common/SelectCategory'

function EditCategory() {
  const Location = useLocation()
  const { state } = useLocation()
  const [val, setVal] = useState();
  
  const befor = (e) => {
    setVal(e.target.files[0])
  }
  const [previews, setPreviewImage] = useState(Location?.state?.images);
    const setPreviews = (e, i = '-1') => {
        if (i == '-1') {
            setPreviewImage([...previews, e.target.files[0]])
        } else {
            let newImages = [...previews].filter((v, x) => x != i);;
            newImages.push(e.target.files[0])
            setPreviewImage(newImages)
        }
    }
  useEffect(() => {
    window.document.getElementById('title-page').innerHTML = "ویرایش  دسته بندی"
  }, []);
  const { add, loadingBtn } = useCategoriesAdmin(true)
  const [oldimages, setoldimages] = useState(Location?.state?.images || [])

  return (
    <Form  submit={add}>
       <input type="hidden" value={Location?.state?.id} name="id" />
       {oldimages.map((img) => {
                return <input type="hidden" value={img} name="oldimages[]" />
            })}
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-md-6">
              <div className='inp-group'>
                <label htmlFor="Name">نام دسته بندی</label>
                <br />
                <input value={state?.name} name='name' type="text" id='name' style={{ width: "100%" }} />
              </div>
            </div>
            <div className="col-md-6">
              <SelectCategory name='parent_id' value={state?.parent ? state?.parent?.id : state?.id} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className='inp-group'>
                <label htmlFor="Name">عنوان صفحه</label>
                <br />
                <input value={state?.seo?.title} name='seo[title]' type="text" id='name' style={{ width: "100%" }} />
              </div>
            </div>
            <div className="col-md-6">
              <div className='inp-group'>
                <label htmlFor="Name">کلمات کلیدی(سئو)</label>
                <br />
                <input value={state?.seo?.keywords} name='seo[keywords]' type="text" id='name' style={{ width: "100%" }} />
              </div>
            </div>
          </div>
          <div className='inp-group'>
            <label htmlFor="Name">توضیحات(سئو)</label>
            <br />
            <input value={state?.seo?.description} name='seo[description]' type="text" id='name' style={{ width: "100%" }} />
          </div>
        </div>
        <div className="col-12">
          <div className='enter-image'>
            <input name='image' type="file" accept="image/*" onChange={befor} />
            {val ?
              <Fragment>
                <img id='image' src={val ? URL.createObjectURL(val) : state?.image} alt="عکس محصول" />
                <div className="add-logo bob">
                  <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM344 304c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88z" />
                  </svg>
                </div>
              </Fragment>
              :
              <div className="add-logo">
                <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM344 304c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88z" />
                </svg>
              </div>
            }
          </div>
        </div>

        
      </div>
      <div className="row">
        <InputButton label="ویرایش" loading={loadingBtn}/>
      </div>
    </Form>
  )
}

export default EditCategory